const Feedback = ({ feedback }) => {
  return (
    <div>
      <div className="about-text-box mb-3">
        <h2 className="mt-0">Reviews</h2>
      </div>
      <div className="star-rating">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={`me-1 star ${star <= feedback?.stars ? 'yellow-star' : 'grey-star'}`}
            data-value={star}
          >
            <i className="fa-solid fa-star"></i>
          </span>
        ))}
        <span className="star ms-2">({feedback?.stars})</span>
      </div>

      <div className="about-text-box">
        <span>{feedback?.message}</span>
      </div>

      <span className="category-box title-box-text rounded-full" style={{ borderRadius: '100px' }}>Completed</span>
    </div>
  );
};

export default Feedback;
